export const formatToTitleCase = (word: string): string => {
  if (!word.length) {
    return word;
  }

  const lowercasedWord = word.toLowerCase();
  return lowercasedWord.charAt(0).toUpperCase() + lowercasedWord.slice(1);
};
